export const heroData = {
  title: '开云官网',
  subtitle: '官方正版入口 · 安全登录体验',
  description: '开云官网是您访问开云平台的官方正版渠道，提供安全稳定的登录入口、丰富的产品服务与极致用户体验。新老用户均可快速注册登录，全天候客服保障您的每一次使用。',
  ctaPrimary: '立即注册',
  ctaSecondary: '安全登录',
  ctaPrimaryLink: '#register',
  ctaSecondaryLink: '#login',
  stats: [
    { value: '500万+', label: '活跃用户' },
    { value: '99.99%', label: '系统稳定性' },
    { value: '7×24h', label: '客服保障' },
    { value: '10年+', label: '品牌历程' },
  ],
};

export const serviceCategories = [
  {
    id: 'entertainment',
    name: '娱乐服务',
    description: '汇聚多元化娱乐服务，打造沉浸式互动体验，满足不同用户的个性化需求',
    icon: 'ri-gamepad-line',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20modern%20entertainment%20lounge%20with%20warm%20golden%20ambient%20lighting%2C%20elegant%20interior%20design%20with%20dark%20wood%20and%20soft%20amber%20accents%2C%20premium%20lifestyle%20atmosphere%2C%20comfortable%20seating%20area%2C%20sophisticated%20decor%20with%20warm%20textures%2C%20clean%20minimal%20aesthetic&width=800&height=600&seq=kaiyun-svc-01&orientation=landscape',
    items: 36,
  },
  {
    id: 'sports',
    name: '体育竞技',
    description: '覆盖全球热门体育赛事，实时数据更新，专业分析助您把握每个精彩瞬间',
    icon: 'ri-football-line',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20modern%20sports%20arena%20with%20dramatic%20warm%20stadium%20lighting%2C%20athletic%20atmosphere%20with%20golden%20evening%20glow%2C%20professional%20sports%20facility%20interior%2C%20clean%20minimal%20design%20with%20warm%20amber%20accents%2C%20elegant%20architectural%20curves&width=800&height=600&seq=kaiyun-svc-02&orientation=landscape',
    items: 48,
  },
  {
    id: 'lifestyle',
    name: '品质生活',
    description: '精选优质生活服务，从购物到旅行，全方位提升您的生活品质与体验',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20lifestyle%20scene%20with%20warm%20golden%20sunset%20light%20through%20large%20windows%2C%20luxurious%20minimalist%20living%20space%20with%20premium%20furnishings%2C%20soft%20textiles%20and%20warm%20amber%20color%20palette%2C%20sophisticated%20urban%20apartment%20aesthetic&width=800&height=600&seq=kaiyun-svc-03&orientation=landscape',
    items: 24,
  },
  {
    id: 'technology',
    name: '科技创新',
    description: '前沿技术驱动，智能算法加持，为您带来安全高效的数字服务体验',
    icon: 'ri-cpu-line',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20modern%20technology%20center%20with%20warm%20golden%20and%20amber%20neon%20accents%2C%20sleek%20minimalist%20server%20room%20design%2C%20clean%20geometric%20patterns%2C%20soft%20ambient%20lighting%20with%20dark%20elegant%20surfaces%2C%20premium%20corporate%20tech%20aesthetic&width=800&height=600&seq=kaiyun-svc-04&orientation=landscape',
    items: 18,
  },
];

export const advantages = [
  {
    id: 'security',
    title: '安全可靠',
    description: '采用国际领先的加密技术，多重安全防护体系，全方位保障您的账户与数据安全，让每一次使用都安心无忧。',
    icon: 'ri-shield-check-line',
  },
  {
    id: 'stable',
    title: '稳定流畅',
    description: '全球分布式服务器架构，智能负载均衡，确保平台7×24小时稳定运行，无论何时何地，畅享流畅体验。',
    icon: 'ri-server-line',
  },
  {
    id: 'service',
    title: '专业服务',
    description: '全天候专业客服团队在线值守，快速响应每一个需求，以贴心周到的服务，解决您使用过程中的任何疑问。',
    icon: 'ri-customer-service-2-line',
  },
  {
    id: 'innovation',
    title: '创新体验',
    description: '持续迭代优化，引入前沿技术，不断丰富产品功能与服务内容，为您创造超越期待的数字化体验。',
    icon: 'ri-lightbulb-flash-line',
  },
  {
    id: 'reputation',
    title: '信誉保障',
    description: '十余年品牌沉淀，数百万用户信赖之选，始终秉持诚信为本的经营理念，用心守护每一位用户的信任。',
    icon: 'ri-medal-line',
  },
  {
    id: 'compliance',
    title: '合规运营',
    description: '严格遵循行业规范与法律法规，持有完备的运营资质，以透明合规的运营准则，构建可持续发展的品牌生态。',
    icon: 'ri-verified-badge-line',
  },
];

export const newsArticles = [
  {
    id: 'article-1',
    slug: 'kaiyun-2024-security-upgrade',
    title: '开云平台完成2024年度安全体系全面升级',
    excerpt: '为进一步提升用户安全保障水平，开云平台近期完成了安全体系的全面升级，引入了新一代智能风控系统与多重验证机制...',
    category: '平台动态',
    date: '2024-12-15',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20security%20center%20with%20warm%20amber%20lighting%2C%20futuristic%20dashboard%20screens%20displaying%20data%2C%20clean%20minimalist%20office%20design%2C%20professional%20atmosphere%20with%20dark%20surfaces%20and%20golden%20accents%2C%20sophisticated%20tech%20environment&width=800&height=500&seq=kaiyun-news-01&orientation=landscape',
  },
  {
    id: 'article-2',
    slug: 'kaiyun-new-service-launch',
    title: '开云平台推出全新智能推荐服务，个性化体验再升级',
    excerpt: '基于深度学习算法的智能推荐系统正式上线，通过对用户行为偏好的精准分析，为每位用户提供量身定制的服务推荐...',
    category: '产品服务',
    date: '2024-11-28',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20product%20launch%20event%20scene%20with%20warm%20golden%20lighting%20and%20dark%20sophisticated%20backdrops%2C%20minimalist%20stage%20design%20with%20soft%20amber%20glow%2C%20premium%20corporate%20event%20atmosphere%2C%20clean%20geometric%20composition&width=800&height=500&seq=kaiyun-news-02&orientation=landscape',
  },
  {
    id: 'article-3',
    slug: 'kaiyun-user-conference-2024',
    title: '2024开云用户大会圆满落幕，共绘未来发展蓝图',
    excerpt: '以"连接·共创·未来"为主题的2024开云用户大会于近日成功举办，来自全国各地的用户代表齐聚一堂，共话平台发展...',
    category: '新闻资讯',
    date: '2024-11-10',
    image: 'https://readdy.ai/api/search-image?query=Grand%20modern%20conference%20hall%20with%20warm%20golden%20chandelier%20lighting%2C%20large%20audience%20in%20elegant%20seating%2C%20professional%20stage%20with%20large%20display%20screens%2C%20sophisticated%20corporate%20event%20design%20with%20dark%20and%20amber%20color%20scheme&width=800&height=500&seq=kaiyun-news-03&orientation=landscape',
  },
  {
    id: 'article-4',
    slug: 'kaiyun-social-responsibility',
    title: '开云平台发布年度社会责任报告，践行企业担当',
    excerpt: '开云平台正式发布2024年度社会责任报告，全面回顾了过去一年在公益慈善、绿色环保、社区共建等方面的工作成果...',
    category: '平台动态',
    date: '2024-10-22',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20social%20responsibility%20scene%20with%20warm%20natural%20sunlight%2C%20green%20sustainable%20office%20environment%2C%20team%20of%20professionals%20collaborating%2C%20clean%20minimalist%20design%20with%20plants%20and%20warm%20wood%20textures%2C%20positive%20optimistic%20atmosphere&width=800&height=500&seq=kaiyun-news-04&orientation=landscape',
  },
];

export const faqItems = [
  {
    id: 'faq-1',
    question: '如何注册开云官网账号？',
    answer: '您可以通过点击首页右上角的"立即注册"按钮，填写手机号或邮箱地址，设置登录密码并完成短信验证，即可快速完成账号注册。整个过程仅需1-2分钟，注册后即可享受开云平台的全部服务。',
  },
  {
    id: 'faq-2',
    question: '开云官网支持哪些登录方式？',
    answer: '开云官网支持手机号登录、邮箱登录以及第三方快捷登录等多种方式。同时，我们还提供扫码登录、指纹识别等便捷登录选项，确保您在安全的前提下享受最便捷的登录体验。',
  },
  {
    id: 'faq-3',
    question: '忘记密码该如何找回？',
    answer: '您可以在登录页面点击"忘记密码"，通过绑定的手机号或邮箱接收验证码，按照系统指引完成身份验证后即可重置密码。如遇任何问题，我们的24小时客服将随时为您提供帮助。',
  },
  {
    id: 'faq-4',
    question: '开云平台如何保障用户信息安全？',
    answer: '我们采用国际标准的加密传输协议（SSL/TLS），配合多重防火墙和入侵检测系统，对用户数据进行分层加密存储。同时，我们定期进行第三方安全审计，确保用户信息得到最高级别的保护。',
  },
  {
    id: 'faq-5',
    question: '开云官网的客服服务时间是怎样的？',
    answer: '开云平台提供7×24小时全天候客服支持，您可以通过在线客服、服务热线、邮件等多种渠道联系我们的专业客服团队。我们的平均响应时间不超过30秒，确保您的每一个问题都能得到及时解决。',
  },
  {
    id: 'faq-6',
    question: '如何验证是否访问的是开云官方正版网站？',
    answer: '请认准开云官网唯一官方域名，我们的网站地址以"https://"开头，浏览器地址栏会显示安全锁标识。您也可以通过官方微信公众号、官方App等渠道获取官网链接，谨防仿冒网站。',
  },
];